import React, { useEffect, useState, useContext } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { Modal, Button, Table, Row, Col, Badge } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { workspace_userActions, organizationActions, work_spaceActions } from '../../../actions';
import { Popup, ElementTooltip } from '../../../components';
import { popUpConstants, userConstants } from '../../../constants';
import SingleInviteForm from "../CollaboratorPage/single_invite_form";
import RoleUpdateForm from "../CollaboratorPage/role_update_form";
import { UserAvatar } from '../../../components';
import { TopbarContext } from '../../../contexts/TopbarContext';
import { tooltipConstants } from '../../../constants';
import { useDisableTimerHook } from '../../../hooks/useDisableTimerHook';

function CollaboratorList(props) {
  const {
    workspaceId,
    handleClose,
    listWorkspaceUser,
    listInviteUsers,
    can_invite_collaborator,
    can_access_user_add_invite,
    current_organization,
    remaining_users,
    ignore_limit
  } = props
  const dispatch = useDispatch();
  const workspace = useSelector(state => state.work_space.currentWorkSpace);
  const isUserRole = localStorage.getItem('user_role');

  const {
    remaining: remainingTimeForInvite,
    disabled: disabledInvite,
    start: startInviteTimer
  } = useDisableTimerHook(userConstants.INVITATION_TIMER_KEY);

  const {
    setActiveOffCanvas,
  } = useContext(TopbarContext);

  useEffect(() => {
    dispatch(workspace_userActions.listCollaborators(workspaceId));
  }, [workspaceId]);

  useEffect(() => {
    if(current_organization && !current_organization.personal){
      dispatch(organizationActions.getAllowedUserDetails(current_organization.id));
    }
  }, [current_organization, listWorkspaceUser, listInviteUsers]);

   const resentInviteUser = (id, params) => {
    if (params === "notification"){
      if(disabledInvite) return;
      
      startInviteTimer();
      dispatch(workspace_userActions.resentNotification(id));
    }else {
      dispatch(workspace_userActions.inviteUserDestroy(id));
    }
  }

  /*
    Popup Modal
  */
  const [popup, setPopUp] = useState({
    show: false,
    id: null,
  });

  const [userDestroyPopUp, setUserDestroyPopUp] = useState({
    show: false,
    id: null,
  });

  const handleCloseDelete = () => {
    setPopUp({show: false, id: null});
  }

  const handleShow = (id) => setPopUp({show: true, id});
  const toggleUserDestroyPopUp = (id) => setUserDestroyPopUp({show: !userDestroyPopUp.show, id: userDestroyPopUp.show ? null : id})

  const handleDelete = () => {
    resentInviteUser(popup.id, "destroy");
    handleCloseDelete();
  }

  const handleUserDestroy = () => {
    dispatch(workspace_userActions.addedUserDestroy(workspaceId, userDestroyPopUp.id));
    toggleUserDestroyPopUp();
  }

  const removeWorkspace = () => {
    dispatch(work_spaceActions.removeWorkspace());
    setActiveOffCanvas(false);
    handleClose();
  }

  const tooltips = [
    {
      tooltip_title: 'Team Lead',
      tooltip_text: tooltipConstants.ROLE_TEAM_LEAD
    },
    {
      tooltip_title: 'Coordinator',
      tooltip_text: tooltipConstants.ROLE_COORDINATOR
    },
    {
      tooltip_title: 'Production',
      tooltip_text: tooltipConstants.ROLE_PRODUCTION
    },
    {
      tooltip_title: 'Spectator',
      tooltip_text: tooltipConstants.ROLE_APPROVER
    },
    {
      tooltip_title: 'Contributor',
      tooltip_text: tooltipConstants.ROLE_CONTRIBUTOR
    }
  ]

  return (
    <Modal show={true} onHide={handleClose} size={"lg"} className="workspace-users-popup">
      <Modal.Header 
        className={'border-0'}
      >
        <Modal.Title>
          Users

          <ElementTooltip
            tooltips={tooltips}
            id={'select-team_lead'}
            className={'ml-1'}
            placement={'auto'}
           >
          </ElementTooltip>
        </Modal.Title>

        {
          current_organization?.personal === false && !ignore_limit &&
          <div className="workspace-users-popup__remaining-seats">
            Seats Available: {remaining_users || 0} of {current_organization.allowed_user_count}.
          </div>
        }
      </Modal.Header>

      <Modal.Body>
        {
          current_organization &&
          <>
            {
              isUserRole === "admin" &&
              <Link
                to={`/organizations/${current_organization.id}/admin/users`}
                onClick={removeWorkspace}
                className="px-1 d-none"
              >
                View Users
              </Link>
            }
          </>
        }
        {can_access_user_add_invite &&
          <SingleInviteForm
            workspaceId={workspaceId}
          />
        }

        <div className='my-3 container-fluid'>
          { listWorkspaceUser && listWorkspaceUser.length > 0
            ?
              listWorkspaceUser.map((data, index) => (
                <Row 
                  key={'list_workspace_user_'+data.id} 
                  className="workspace-users-popup__user-row px-3 py-1"
                >
                  <Col lg={9} className={'d-flex align-items-center'}>
                    <UserAvatar
                      containerClassName={'avatar_container'}
                      icon={ data.logo.url ? data.logo.url : null }
                      name={ data.name }
                      name_initials={ data.name_initials }
                      size="30.31"
                    />

                    <div className="p-1 text-truncate">
                      <div className="workspace-users-popup__name text-truncate">
                        { data.name }
                        { data.status && <span className="mx-1">({ data.status })</span> }
                      </div>

                      {
                        can_access_user_add_invite &&
                        <div className="workspace-users-popup__email text-truncate">
                          { data.email }
                        </div>
                      }
                    </div>
                  </Col>
                  <Col className="position-relative d-flex align-items-center" lg={3}>
                    {
                      data.is_admin ?
                        data?.roles?.map((role, index) => (
                          <div key={index} className="form-control d-flex align-items-center admin-role">
                            <span className="proper-text">{role}</span>
                          </div>
                        ))
                      :
                        <RoleUpdateForm
                          workspaceId={workspaceId}
                          roles={data && data.roles}
                          user_id = {data.id}
                          handleShowDelete={() => toggleUserDestroyPopUp(data.id)}
                        />
                    }
                  </Col>
                </Row>
              ))
            :
              <Row>
                <Col sm={12}>
                  <div className="text-center py-3">There are no users yet.</div>
                </Col>
              </Row>
          }

          { can_access_user_add_invite && listInviteUsers && listInviteUsers.length > 0
              ?
              listInviteUsers.filter(d => d.status === "Invited").map((data, index) => (
                <Row key={"listInviteUsers_"+index} className='px-3 py-1'>

                  <Col lg={9} className={'d-flex align-items-center'}>
                    <div className="avatar_container" />
                    <div className="p-1 text-truncate">
                      <div className='d-flex'>
                        <div className={`workspace-users-popup__email text-truncate me-2`}>
                          { data.email }
                        </div>

                        <Badge 
                          className={`workspace-users-popup__pending-invitation-label badge-outline ${disabledInvite ? 'disabled' : ''}`}
                          size={"sm"}
                          bg={"orange"}
                          onClick={() => resentInviteUser(data.id, "notification")}
                        >
                          Resend
                        </Badge>

                      </div>
                    </div>
                  </Col>


                  <Col lg={3} className="position-relative">
                    <RoleUpdateForm
                      workspaceId={workspaceId}
                      roles={data && data.invited_workspace_users}
                      user_id={data.id}
                      userType={true}
                      handleShowDelete={() => handleShow(data.id)}
                    />
                  </Col>
                </Row>
                ))
              :
                null
            }
        </div>

        {popup.show &&
          <Popup
            display_text={ popUpConstants.INVITED_USER_DELETE }
            delete_btn_text={'Yes'}
            close_btn_text={'Cancel'}
            handleClose={handleClose}
            handleDelete={handleDelete}
          />
        }

        {userDestroyPopUp.show &&
          <Popup
            display_text={
              `Remove user from workspace?`
            }
            delete_btn_text={'Yes'}
            close_btn_text={'Cancel'}
            handleClose={toggleUserDestroyPopUp}
            handleDelete={handleUserDestroy}
          />
        }

      </Modal.Body>
    </Modal>
  );
}


const mapStateToProps = (state) => {
  return {
    can_invite_collaborator: state.workspaceUser.can_invite_collaborator,
    listWorkspaceUser: state.workspaceUser.listWorkspaceUser,
    listInviteUsers: state.workspaceUser.listInviteUsers,
    current_organization: state.organization.current_organization,
    remaining_users: state.organization.remaining_users,
    ignore_limit: state.organization.ignore_limit,
    can_access_user_add_invite: state.workspaceUser.can_access_user_add_invite
  };
};

export default connect(mapStateToProps, { workspace_userActions })(CollaboratorList);
